export default __webpack_public_path__ + "static/media/statusClosed.be66cd67.svg";